import { useEffect, useState } from "react";
import { getMetric } from "./AnalyticsUtils";
import FlexWrapper from "../FlexWrapper";
import Tooltip from "../../components/popups/Tooltip";
import LoadingIcon from "../Shared/LoadingIcon";
import PageGridDivider from "../Shared/Page/PageGridDivider";
import './AnalyticsPage.scss'

const AnalyticsMetricsBanner = (props) => {
    const { data, guidelines, loading, parentData } = props
    const [metrics, setMetrics] = useState(null)

    useEffect(() => {
        if (guidelines && data) {
            const formattedGidelines = guidelines.map(g => {
                const formattedDatum = getMetric(data, g, parentData)
                return formattedDatum
            })
            //console.log('FORMATTED GUIDELINES', formattedGidelines)
            setMetrics(formattedGidelines)
        }
    }, [guidelines, data])

    return (
        <>
            <FlexWrapper gap="xl" style={{ paddingBottom: "1rem" }}>
                {metrics && metrics.length > 0 && metrics.map((datum, index) => {
                    //console.log("DATUM", datum)
                    const { label, value } = datum
                    return (
                        datum.tooltip ?
                            <Tooltip disabled={value === 0} label={datum.tooltip}>
                                <FlexWrapper gap="xs" direction="column" align="flex-start" key={"toltip-metric-block-" + index} >
                                    <label className='total-metrics-label'>{label}</label>
                                    {loading ? <LoadingIcon size={32} /> : value === 0 ? <h1>-</h1> : value}
                                </FlexWrapper>
                            </Tooltip>
                            :
                            <FlexWrapper gap="xs" direction="column" align="flex-start" key={"metric-block-" + index} >
                                <label className='total-metrics-label'>{label}</label>
                                {loading ? <LoadingIcon size={32} /> : <h1 className='total-metrics-value'>{value}</h1>}
                            </FlexWrapper>
                    )
                })}
            </FlexWrapper>
            <PageGridDivider />
        </>
    );
}

export default AnalyticsMetricsBanner;